import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vant from 'vant';
import 'vant/lib/index.css';
import 'vant/lib/index.less';
import Vuei18n from "vue-i18n";
import VueClipboard from 'vue-clipboard2'
import * as axios from 'axios';
import * as moment from 'moment';
import register from './registerDialog'; // 注册弹窗

Vue.prototype.moment = moment;

Vue.use(VueClipboard)

import en_US from '@/assets/lang/en_US'; // 英文
import zh_HK from '@/assets/lang/zh_HK'; // 繁体中文（香港）
import tr_TR from '@/assets/lang/tr_TR'; // 土耳其语
import es_ES from '@/assets/lang/es_ES'; // 西班牙语
import en_XA from '@/assets/lang/en_XA'; // 阿拉伯语
import pt_PT from '@/assets/lang/pt_PT'; // 葡萄牙语
import de_DE from '@/assets/lang/de_DE'; // 德语
import fr_FR from '@/assets/lang/fr_FR'; // 法语
import ja_JP from '@/assets/lang/ja_JP'; // 日语
import ko_KR from '@/assets/lang/ko_KR'; // 韩语
import it from '@/assets/lang/it'; // 意大利语
import ru from '@/assets/lang/ru'; // 俄语


Vue.use(Vuei18n); 
let locale = 'en_US';
if (localStorage.getItem('language')) {
  locale = localStorage.getItem('language');
} else if (['en_US', 'zh_HK', 'es_ES', 'tr_TR', 'en_XA', 'pt_PT', 'de_DE', 'fr_FR', 'ja_JP', 'ko_KR', 'it', 'ru'].includes(navigator.language)) {
  locale = navigator.language;
}
const i18n = new Vuei18n({
  locale, 
  messages:{
    'en_US':{...en_US},
    'zh_HK':{...zh_HK},
    'tr_TR':{...tr_TR},
    'es_ES': {...es_ES},
    'en_XA':{...en_XA},
    'pt_PT':{...pt_PT},
    'de_DE':{...de_DE},
    'fr_FR':{...fr_FR},
    'ja_JP':{...ja_JP},
    'ko_KR':{...ko_KR},
    'it':{...it},
    'ru':{...ru}
  }, 
  silentTranslationWarn: false, // 是否关闭翻译报错; 
});
Vue.use(Vant);

Vue.prototype.axios = axios;
Vue.prototype.apiV1 = axios.create({
    // baseURL: `http://192.168.2.28:8880/v1/c`,
    baseURL: `https://api.${document.domain}/v1/c`,
    timeout: 0
});
Vue.prototype.apiV1.interceptors.response.use(function (response) {
    // 对响应数据做点什么
    const { data: res } = response;
    if (!res.success) {
      if (['Login expiration', 'LoginRequiredError', 'Login exception', 'Illegal request', 'Permission denied'].includes(res.message)) {
        if (localStorage.getItem('token')) {
          localStorage.removeItem('addr');
          localStorage.removeItem('token');
          location.reload();
        }
      } else if (res.message instanceof Array) {
        Vue.prototype.$toast.fail(res.message[0].field + ' ' + res.message[0].message);
      } else {
        Vue.prototype.$toast.fail(res.message);
      }
    }
    return response;
}, function (error) {
    const message = error.message instanceof Object ? JSON.stringify(error.message):error.message;
    Vue.prototype.$toast.fail(message);
});

Vue.prototype.login = async function(code) {
  let tronWeb;
  // 连接钱包
  if (typeof window.okxwallet !== 'undefined') {
      console.log('OKX is installed!');
      const result = await window.okxwallet.tronLink.request({ method: 'tron_requestAccounts'}).catch((error)=>{
          console.log(error);
      })
      if (result.code !== 200) {
          this.$notify({ type: 'warning', duration: 0, message: 'User rejected' });
          return;
      }
      tronWeb = window.okxwallet.tronLink.tronWeb;
  } else if (window.tronWeb) {
      tronWeb = window.tronWeb;
  } else if (!window.ethereum) {
      this.$notify({ type: 'warning', duration: 0, message: i18n.t('Please_open_the_website_in_the_Dapp_browser') });
      return;
  }
  let addr, base58Addr;
  if (window.ethereum) {
    try {
      // await ethereum.enable();
      const accountsOnEnable = await window.ethereum.request({method: 'eth_requestAccounts'});
      addr = accountsOnEnable[0];
    } catch (error) {
      console.log(error);
    }
  }
  if (tronWeb) {
    base58Addr = tronWeb.defaultAddress.base58
  }
  if (!addr && !base58Addr) {
      this.$notify({ type: 'warning', message: i18n.t('Please_unlock_your_wallet') });
      return;
  }
  const token = localStorage.getItem('token');
  const has_login_addr = localStorage.getItem('addr');
  if (token && (addr === has_login_addr || base58Addr === has_login_addr)) {
    return;
  } else {
    // localStorage.clear();
    localStorage.removeItem('addr');
    localStorage.removeItem('token');
  }
  console.log('addr:', addr);
  console.log('base58Addr:', base58Addr);
  for (const uaddr of [addr, base58Addr]) {
    if (!uaddr) {
      continue;
    }
    const response = await Vue.prototype.apiV1({
        method: 'post',
        url: '/login',
        data: {
          addr: uaddr
        }
    });
    const { success, data } = response.data;
    if (success) {
      if (data.uid) { // 已经注册绑定，进行签名登录
        localStorage.setItem('chainId', data.chainId);
        localStorage.setItem('addr', data.addr);
        localStorage.setItem('token', data.token);
        location.reload();
        return;
      }
    }
  }
  register.install(code, addr, base58Addr); // // 未注册，引导绑定邀请码注册
}

Vue.config.productionTip = false

new Vue({
  router,
  i18n,
  store,
  render: h => h(App)
}).$mount('#app')
